/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_TitleInputs */

const en_newsletter_archive_title = /** @type {(inputs: Newsletter_Archive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Newsletter`)
};

/**
* | output |
* | --- |
* | "The Newsletter" |
*
* @param {Newsletter_Archive_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_title = /** @type {((inputs?: Newsletter_Archive_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_title(inputs)
});